import { SVGProps } from "react"

const CheckNewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M16.6663 5L7.49967 14.1667L3.33301 10"
      stroke={props.color || "#011727"}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default CheckNewIcon
